import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */

import { useContext } from 'react';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import DividedSeeMore from '../DividedSeeMore';
import SearchContext from './SearchContext';
import PeopleListItem from './PeopleListItem';
import LoadingSkeleton from './LoadingSkeleton';
const PREFIX = 'PeopleList';
const classes = {
  root: `${PREFIX}-root`,
  list: `${PREFIX}-list`,
  listItem: `${PREFIX}-listItem`,
  loadMore: `${PREFIX}-loadMore`,
  suggested: `${PREFIX}-suggested`
};
const Root = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  [`&.${classes.root}`]: {
    width: '100%'
  },
  [`& .${classes.list}`]: {
    listStyle: 'none',
    margin: spacing(2, 0, 3, 0),
    padding: 0
  },
  [`& .${classes.listItem}`]: {
    '&:not(:last-child)': {
      borderBottom: `1px solid ${palette.layout.line.divider}`
    }
  },
  [`& .${classes.loadMore}`]: {
    marginBottom: spacing(3)
  },
  [`& .${classes.suggested}`]: {
    marginBottom: spacing(4)
  }
}));
export default function PeopleList(t0) {
  const $ = _c(21);
  const {
    translations,
    isLoadMoreDisabled: t1,
    suggestedExpert: t2
  } = t0;
  const isLoadMoreDisabled = t1 === undefined ? false : t1;
  const suggestedExpert = t2 === undefined ? null : t2;
  const {
    isPending,
    peopleList,
    total,
    onLoadMore,
    canFetchMore,
    onSelect,
    isFetchingMore,
    query,
    fetchStatus,
    status,
    errorCode
  } = useContext(SearchContext);
  if (isPending) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <LoadingSkeleton />;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  if (!isPending && total === 0 && !suggestedExpert?.id && !errorCode) {
    const t3 = fetchStatus === "idle" && status === "pending" ? translations.typeSomething : translations.noResults;
    let t4;
    if ($[1] !== t3) {
      t4 = <Typography component="div" variant="subheadingSmall">{t3}</Typography>;
      $[1] = t3;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  if (errorCode) {
    let t3;
    if ($[3] !== translations.noResults) {
      t3 = <Typography component="div" variant="subheadingSmall">{translations.noResults}</Typography>;
      $[3] = translations.noResults;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const hasQuery = query !== "";
  let t3;
  if ($[5] !== hasQuery || $[6] !== onSelect || $[7] !== peopleList || $[8] !== suggestedExpert || $[9] !== total || $[10] !== translations) {
    t3 = peopleList && <>{suggestedExpert && !hasQuery && <div className={classes.suggested} data-testid="suggestedItem"><PeopleListItem userId={suggestedExpert.id} userName={suggestedExpert.displayName} subHeading={translations.suggested} avatarUrl={suggestedExpert.avatar} onClick={() => onSelect(suggestedExpert)} /></div>}<Typography component="div" sx={{
        color: "text.onMainSecondary"
      }} variant="subheadingSmall">{translations.resultCount({
          peopleCount: total
        }, total)}</Typography><ul className={classes.list}>{peopleList.map(people => <li key={people.id} className={classes.listItem}><PeopleListItem isSelected={people.isSelected} userId={people.id} userName={people.displayName} subHeading={people.subHeading} avatarUrl={people.avatar} onClick={() => onSelect(people)} /></li>)}</ul></>;
    $[5] = hasQuery;
    $[6] = onSelect;
    $[7] = peopleList;
    $[8] = suggestedExpert;
    $[9] = total;
    $[10] = translations;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== canFetchMore || $[13] !== isFetchingMore || $[14] !== isLoadMoreDisabled || $[15] !== onLoadMore || $[16] !== translations) {
    t4 = canFetchMore && !isLoadMoreDisabled && <div className={classes.loadMore}><DividedSeeMore onClick={onLoadMore} isLoading={Boolean(isFetchingMore)} translations={{
        seeMore: translations.loadMore
      }} /></div>;
    $[12] = canFetchMore;
    $[13] = isFetchingMore;
    $[14] = isLoadMoreDisabled;
    $[15] = onLoadMore;
    $[16] = translations;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t3 || $[19] !== t4) {
    t5 = <Root className={classes.root}>{t3}{t4}</Root>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}